import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "电影", path: "/category/movie" },
  { label: "电视剧", path: "/category/tv" },
  { label: "资讯", path: "/news" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/search?keyword=${encodeURIComponent(kw)}` : "/search");
    setMenuOpen(false);
  };

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:px-6 lg:h-18">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-movie-2-line text-lg" />
          </span>
          <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
            四虎视频
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.path)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden md:block">
          <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100/80 px-3 py-1.5 focus-within:border-primary-300 focus-within:bg-background-50">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影、电视剧、资讯"
              className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none lg:w-56"
            />
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="animate-slide-down border-t border-background-200/70 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <form onSubmit={handleSearch} className="mb-3">
            <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-background-100/80 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索电影、电视剧、资讯"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`rounded-md px-3 py-2.5 text-sm font-medium ${
                  isActive(item.path)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}